import { render, staticRenderFns } from "./appearanceDppmPage.vue?vue&type=template&id=74975846&scoped=true&"
import script from "./appearanceDppmPage.vue?vue&type=script&lang=js&"
export * from "./appearanceDppmPage.vue?vue&type=script&lang=js&"
import style0 from "./appearanceDppmPage.vue?vue&type=style&index=0&id=74975846&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74975846",
  null
  
)

export default component.exports